// JSON colapsable para metadata/custom_data — <details> nativo, sin librerías.

export function JsonView({ value, label = 'json' }: { value: unknown; label?: string }) {
  if (value === null || value === undefined) {
    return <span className="text-ink-subtle">—</span>;
  }
  const text = JSON.stringify(value, null, 2);
  if (text === '{}' || text === '[]') return <span className="text-ink-subtle">{text}</span>;
  return (
    <details className="group">
      <summary className="cursor-pointer select-none text-[10px] uppercase tracking-wider text-brand hover:text-brand-hover">
        {label} <span className="text-ink-subtle group-open:hidden">▸</span>
        <span className="hidden text-ink-subtle group-open:inline">▾</span>
      </summary>
      <pre className="mt-1 max-h-48 overflow-auto rounded bg-surface-muted p-2 text-[10px] leading-relaxed text-ink-muted">
        {text}
      </pre>
    </details>
  );
}
